import PageItemWrapper, { IPageItemattributes } from '../page-item-wrapper/page-item-wrapper';
import IconPrevPage from '../../../../../icons/icon-prev-page/icon-prev-page';
import Button from '../button/button';
import { IPaginationButtonProps } from '../../../../table.types';
import Icon from '../../../../../icons/icon/icon';

const First: React.FC<IPaginationButtonProps> = ({ onClick, isActive, activeColor }) => {
    const attributes: IPageItemattributes = { 'aria-label': '« First' }

    return (
        <PageItemWrapper {...attributes} classList={['first']}>
            {isActive ?
                <Button onClick={onClick} label="« First">
                    <Icon Component={IconPrevPage} color={activeColor} />
                    <Icon Component={IconPrevPage} color={activeColor} />
                </Button> :
                <span className="page-link" aria-disabled="true">
                    <Icon Component={IconPrevPage} disabled />
                    <Icon Component={IconPrevPage} disabled />
                </span>
            }

        </PageItemWrapper>
    )
}

export default First;
